import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import './assets/animations.css'

//import posthogPlugin from "./plugins/posthog";
//import * as amplitude from '@amplitude/analytics-browser';
//amplitude.init('a02b49eba1c2afff156d27a676166464', {"autocapture":true,"serverZone":"EU"});

// Font Awesome setup
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faUser, faSignInAlt, faSignOutAlt, faArrowRight, faBell, faStar, 
  faThLarge, faCalendar, faCalendarDay, faRunning, faCommentDots, faComments,
  faCrown, faTag, faPercent, faQuestion, faEye, faLock, faEllipsisH, faInfo,
  faChevronDown, faChevronUp, faPlus, faMinus, faExchangeAlt, faTimes, faExclamationCircle,
  faCreditCard, faCoins, faBars
} from '@fortawesome/free-solid-svg-icons'

// Custom directives
import scrollAnimation from './directives/scrollAnimation'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'

// Add icons to the library
library.add(
  faUser, faSignInAlt, faSignOutAlt, faArrowRight, faBell, faStar,
  faThLarge, faCalendar, faCalendarDay, faRunning, faCommentDots, faComments,
  faCrown, faTag, faPercent, faQuestion, faEye, faLock, faEllipsisH, faInfo,
  faChevronDown, faChevronUp, faPlus, faMinus, faExchangeAlt, faTimes, faExclamationCircle,
  faCreditCard, faCoins, faBars
)

const app = createApp(App)

    // app.provide('hostname', 'http://localhost:8073')
 app.provide('hostname', 'https://carddy.tech/api')

app.use(VueAxios,axios);

app.use(VueCookies);


//app.use(posthogPlugin);

app.component('font-awesome-icon', FontAwesomeIcon)
app.directive('scroll-animation', scrollAnimation)
app.use(router)
app.mount('#app')

// Prevent browser print/scan detection
if (typeof window !== 'undefined') {
  // Override the print function
  window.print = function() {
    console.log('Print functionality is disabled');
    return false;
  };
  
  // Add event listener to capture print attempts
  window.addEventListener('beforeprint', (event) => {
    event.preventDefault();
    event.stopPropagation();
    return false;
  });
  
  // Disable keyboard shortcuts for printing
  window.addEventListener('keydown', (e) => {
    // Ctrl+P or Command+P
    if ((e.ctrlKey || e.metaKey) && e.keyCode === 80) {
      e.preventDefault();
      return false;
    }
  });
}
